
/**
 * import中的webpackChunkName，为按需加载生成的JS名称，请使用 [project-name]-[module-name]，示例如下
 */
export default [
  {
    path: '/session/session_service',
    name:'/session/session_service',
    meta:{
        title:'服务问题管理'
    },
    component: () =>
        import ( /* webpackChunkName: "example-session" */ '../views/session/session_service.vue')
  },
  {
    path: '/session/session_chat',
    name:'/session/session_chat',
    meta:{
        title:'对话记录管理'
    },
    component: () =>
        import ( /* webpackChunkName: "example-session" */ '../views/session/session_index.vue')
  },
  {
    path: '/session/business_sessions/business_session',
    name:'/business_session',
    meta:{
        title:'商家会话管理'
    },
    component: () =>
        import ( /* webpackChunkName: "example-session" */ '../views/session/business_sessions/business_session.vue')
  },
  {
    path: '/session/seesionList_box',
    name: '/seesionList_box',
    meta: {
      title: '聊天记录'
    },
    component: () =>
      import ( /* webpackChunkName: "example-session" */ '../views/session/seesionList_box.vue')
  }
]
